import React, { useState, useContext } from "react";

import MainSearch from "./SearchFilter";
import MainFilter from "../common/MainFilter";

import db from "../../services/query";

const Filter = ({ query, hasFilter }) => {
  const [filter, showFilter] = useState(false);

  const [genderList, getGender] = useState([]);
  const [facultyList, getFaculty] = useState([]);

  useState(async () => {
    const ac = new AbortController();

    await db
      .getAll(`dropdowns/faculties`)
      .then(({ data: { data } }) => getFaculty(data));

    await db
      .getAll(`dropdowns/genders`)
      .then(({ data: { data } }) => getGender(data));

    return () => ac.abort();
  }, []);

  const inputs = [
    {
      name: "teacher_name",
      label: "نام",
      type: "text",
      maxLength: 32,
    },
    {
      name: "teacher_phone",
      label: "شماره تماس",
      type: "text",
      maxLength: 14,
    },
    {
      name: "faculty_id",
      label: "پوهنحی",
      type: "select",
      data: facultyList,
    },
    {
      name: "gender_id",
      label: "جنسیت",
      type: "select",
      data: genderList,
    },
    {
      name: "aria_id",
      label: "کد استاد",
      type: "text",
      maxLength: 20,
    },
    {
      name: "user_status",
      label: "وضعیت",
      type: "select",
      data: [{id: "1" , name: "برحال"}, {id: "0", name: "اسبق"}],
    }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      teacher_name,
      teacher_phone,
      faculty_id,
      gender_id,
      aria_id,
      user_status,
    } = e.target;

    query({
      keyword: teacher_name.value,
      teacher_phone: teacher_phone.value,
      faculty_id: faculty_id.value,
      gender_id: gender_id.value,
      aria_id: aria_id.value,
      user_status: user_status.value,
    });
  };

  return (
    <React.Fragment>
      <MainSearch showFilter={showFilter} query={query} hasFilter={hasFilter} />
      {filter && (
        <MainFilter
          handleSubmit={handleSubmit}
          showFilter={showFilter}
          filter={filter}
          inputs={inputs}
          query={query}
        />
      )}
    </React.Fragment>
  );
};

export default Filter;
